import React from 'react';

// Create a context with no initial values.
export const ProductContext = React.createContext();

export default ProductContext;
